// extracted by mini-css-extract-plugin
module.exports = {"chip":"Chip_chip__4PFXE","active":"Chip_active__iS4qO","sm":"Chip_sm__uM1sM","md":"Chip_md__I1FNX"};